<!--
/**
* @name: List.vue
* @description: 门店陈列活动-列表页
* @author: 杨波
* @create: 2022/05/19 09:40:37
* @update: 2020/05/19 09:40:37
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入门店陈列活动名称" block clearable v-model="para.activityName"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择活动状态" clearable block v-model="para.status">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择启停用状态" clearable block v-model="para.isEnabled">
          <k-option v-for="item in isEnabled" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="handleLinkToDetail({}, 0)">新建</y-button>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="dataList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>
<script>
import { NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_PAGE_LIST, NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_STATUS_TOGGLE } from "@/assets/modules/apiList";
const initPara = () => ({
  activityName: "", //陈列活动名称
  isEnabled: "", //启停用状态
  status: "", //活动状态
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      isLoading: false,
      para: initPara(),
      dataList: [],
      statusList: [
        { value: "not_start", label: "未开始" },
        { value: "ongoing", label: "进行中" },
        { value: "finished", label: "已结束" },
      ],
      isEnabled: [
        { value: true, label: "启用" },
        { value: false, label: "禁用" },
      ],
      total: 0,
    };
  },
  methods: {
    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w ? w : 80,
        "text-align": "center",
        "white-space": "normal",
        "word-break": "break-all",
      };
    },

    /** 初始化表格 */
    initColumns() {
      let tableItem = [
        { name: "序号", style: this.tableStyle(80), customRender: (row) => <div>{row.id ? row.id : "——"}</div> },
        { name: "活动名称", style: this.tableStyle(150), customRender: (row) => <div>{row.activityName ? row.activityName : "——"}</div> },
        {
          name: "提交门店",
          style: this.tableStyle(80),
          customRender: (row) => (
            <a
              href="javascript:;"
              onClick={(e) => {
                e.stopPropagation();
                this.onViewSubmitStore(row);
              }}
            >
              {row.shopNumber}
            </a>
          ),
        },
        { name: "活动状态", style: this.tableStyle(80), customRender: (row) => <div>{row.statusName ? row.statusName : "——"}</div> },
        {
          name: "活动时间",
          style: this.tableStyle(180),
          customRender: (row) => {
            return (
              <div>
                {row.startTime}~{row.endTime}
              </div>
            );
          },
        },
        {
          name: "状态",
          style: this.tableStyle(60),
          customRender: (row) => {
            return (
              <k-switch
                checked={row.isEnabled}
                readonly
                onClick={() => {
                  this.onChangeStatus(row);
                }}
              />
            );
          },
        },
        { name: "创建时间", style: this.tableStyle(100), customRender: (row) => <div>{row.createTime ? row.createTime : "——"}</div> },
        {
          name: "操作",
          style: this.tableStyle(70),
          customRender: (row) => (
            <div>
              {(row.status === "not_start" || row.status === "ongoing") && (
                <a href="javascript:;" onclick={() => this.handleLinkToDetail(row, 1)}>
                  编辑&#12288;
                </a>
              )}
              <a href="javascript:;" onclick={() => this.handleLinkToDetail(row, 2)}>
                查看
              </a>
            </div>
          ),
        },
      ];
      return tableItem;
    },

    /** 查看门店陈列活动-提交门店 */
    onViewSubmitStore(row) {
      this.$controller.open({
        name: "applyManagement",
        query: {
          refresh: new Date() - 0,
          id: row.id ? row.id : "",
        },
        title: "提交门店列表",
      });
    },

    /** 门店陈列活动添加\编辑\查看操作 */
    handleLinkToDetail(row, showType) {
      // showType 0：添加，1：编辑，2：查看
      this.$controller.open({
        name: "exhibitDetail",
        query: {
          refresh: new Date() - 0,
          showType: showType,
          id: row.id ? row.id : "",
        },
        title: `门店陈列活动-${["添加", "编辑", "详情"][showType]}`,
      });
    },

    /** 门店陈列活动状态启/停用切换操作 */
    onChangeStatus(row) {
      this.$dialog({
        title: "提示",
        content: `${row.isEnabled == true ? "是否确认停用当前门店陈列活动？" : "是否确认启用当前门店陈列活动？"}`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_STATUS_TOGGLE,
            para: { id: row.id },
          })
            .then(() => {
              this.isLoading = false;
              this.$root.tip("操作成功", "success");
              this.getExhibitList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 刷新门店陈列活动列表 */
    getExhibitList() {
      let { para } = this;
      this.isLoading = true;
      this.$fetch({ api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_PAGE_LIST, para })
        .then((res) => {
          this.dataList = res.pageList || [];
          this.total = res.total;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 条件查询门店陈列活动列表 */
    onSearch() {
      this.para.pageCurrent = 1;
      this.getExhibitList();
    },

    /** 清空门店陈列活动列表查询条件 */
    onReset() {
      this.para = initPara();
      this.getExhibitList();
    },

    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getExhibitList();
    },
  },
  async created() {
    this.getExhibitList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getExhibitList();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 230px !important;
}
</style>
